
import { defineComponent, nextTick, onMounted, reactive, toRefs } from "vue";
import Header from "@/components/header/Comheader.vue";
import { useRoute, onBeforeRouteUpdate } from "vue-router";
import axios from "axios";

export default defineComponent({
  components: {
    Header,
  },
  setup() {
    const route: any = useRoute();
    const proxyData = reactive({
      route: route,
      transitionName: "slide-right",
      showHeader: false,
      getPadVersion() {
        axios.get(`/sgipad/pad_mtime`).then((res: any) => {
          let data: any = res.data || {};
          let pad_mtime: any = data.pad_mtime;
          let oldTime: any = localStorage.getItem("pad_mtime");
          if (oldTime && oldTime !== pad_mtime) {
            localStorage.setItem("pad_mtime", pad_mtime);
            window.location.reload();
          } else {
            localStorage.setItem("pad_mtime", pad_mtime);
          }
        });
      },
      timerPadVersion() {
        setInterval(() => {
          proxyData.getPadVersion();
        }, 5000);
      },
    });
    nextTick(() => {
      const document: any = window.document;
      document.addEventListener("touchstart", function (event: any) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener("gesturestart", function (event: any) {
        event.preventDefault();
      });
    });
    onMounted(() => {
      proxyData.timerPadVersion();
    });
    return {
      ...toRefs(proxyData),
    };
  },
});
